import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.js";

// Mount the React root. Fail fast if the mount node is missing (no silent
// no-op) — it means index.html and this entry have drifted.
const root = document.getElementById("root");
if (!root) {
  throw new Error("#root element not found in index.html");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);
